import { useEffect, useState } from "react";
import { http } from "./api";

export const BUCKETS = ["Current", "1-30", "31-60", "61-90", "91-120", "121-150", "151-180", ">180"];
export const BUCKET_CLS = { Current: "bg-emerald-50 text-emerald-700 border-emerald-200", "1-30": "bg-amber-50 text-amber-700 border-amber-200", "31-60": "bg-orange-50 text-orange-700 border-orange-200" };
export const bucketCls = (b) => BUCKET_CLS[b] || "bg-rose-50 text-rose-700 border-rose-200";
export const fmt = (v, cur = "MXN") => (v === null || v === undefined ? "Sin dato" : `${cur === "USD" ? "US$" : "$"}${Number(v).toLocaleString("es-MX", { maximumFractionDigits: 0 })}`);
export const pct = (v, d = 1) => (v === null || v === undefined ? "Sin dato" : `${(v * 100).toFixed(d)}%`);
const MES = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
export const fechaCorte = (iso) => (iso ? `Datos al ${Number(iso.slice(8, 10))}-${MES[Number(iso.slice(5, 7)) - 1]}-${iso.slice(0, 4)}` : "");
export const CorteBadge = ({ iso, testid = "corte-badge" }) => (iso ? <span data-testid={testid} className="rounded-full border border-[#13315C]/20 bg-[#13315C]/5 px-3 py-1.5 text-xs font-semibold text-[#13315C]">{fechaCorte(iso)}</span> : null);

// Dataset activo: los no-admin solo ven la cartera real
export const useDataset = () => {
  const [info, setInfo] = useState(null);
  const [ds, setDsState] = useState("sofipo");
  useEffect(() => { http.get("/lm/info").then((r) => setInfo(r.data)); }, []);
  const setDs = (v) => { localStorage.setItem("lm-ds", v); setDsState(v); };
  const efectivo = info && !info.admin ? "sofipo" : ds;
  return { info, ds: efectivo, setDs };
};

export const DatasetSelect = () => null;
export const Kpi = ({ l, v, testid, sub }) => (
  <div className="rounded-2xl border border-[#E2DDD5] bg-white p-4 transition-transform duration-200 hover:-translate-y-0.5">
    <p className="text-[10px] font-semibold uppercase tracking-widest text-[#8C867A]">{l}</p>
    <p className="font-serif-display text-2xl font-bold tabular-nums" data-testid={testid}>{v}</p>
    {sub && <p className="text-xs text-[#8C867A]">{sub}</p>}
  </div>
);

export const Tabs = ({ tabs, tab, setTab }) => (
  <div className="flex flex-wrap gap-1 rounded-2xl border border-[#E2DDD5] bg-white p-1">
    {tabs.map(([k, l]) => (
      <button key={k} data-testid={`tab-${k}`} onClick={() => setTab(k)}
        className={`rounded-xl px-4 py-2 text-sm font-semibold transition-colors ${tab === k ? "bg-[#111] text-white" : "text-[#5C5850] hover:bg-[#F2F0EC]"}`}>{l}</button>))}
  </div>
);

export const PageHead = ({ kicker, title, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-4">
    <div><p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#8C867A]">{kicker}</p>
      <h1 className="font-serif-display text-4xl font-bold sm:text-5xl">{title}<span className="text-[#E8643C]">.</span></h1></div>
    <div className="flex flex-wrap items-center gap-3">{children}</div>
  </div>
);
